module.exports = __webpack_public_path__ + "static/img/join.7b88a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join.png
// module id = IDVU
// module chunks = 10